<template>
  <div id="wording-dialog">
    <v-dialog max-width="400px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-btn @click="addItem()" color="primary" dark v-on="on">Create</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title>
          <h1 class="title head-page">Counsulting Topic</h1>
        </v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout align-center justify-center row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :items="wordingTypes"
                  clearable
                  item-text="name"
                  item-value="idx"
                  label="Wording Type"
                  v-model="formData.wordingTypeId"
                ></v-autocomplete>
                <v-text-field clearable label="Text" v-model="formData.wordingText"></v-text-field>
                <v-autocomplete
                  :items="categorieTypes"
                  clearable
                  item-text="nametha"
                  item-value="typeid"
                  label="Categorie Type"
                  v-model="formData.categorieTypeId"
                ></v-autocomplete>
                <v-autocomplete
                  :items="pages"
                  clearable
                  item-text="name"
                  item-value="idx"
                  label="Pages"
                  v-model="formData.pageId"
                ></v-autocomplete>
                <v-autocomplete
                  :items="regions"
                  clearable
                  item-text="nametha"
                  item-value="idx"
                  label="Region"
                  v-model="formData.regionId"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <base-delete-button :idx="formData.idx" module="Wording"></base-delete-button>
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn>
          <v-btn :loading="dialogLoading" @click.prevent="doSubmit()" color="green" dark
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'wording-dialog',
  data() {
    return {
      formData: [],
      dialogLoading: false
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.Wording.idx) {
        this.formData = this.$store.getters['Wording/getAll'].filter(
          item => item.idx == this.$store.state.Wording.idx
        )[0]
      } else {
        this.formData = []
      }
    }
  },
  computed: {
    categorieTypes() {
      return this.$store.getters['Types/getAll'].filter(item => item.orders == 0)
    },
    regions() {
      return this.$store.getters['Place/getRegionAll']
    },
    wordingTypes() {
      return this.$store.getters['WordingType/getAll']
    },
    pages() {
      return this.$store.getters['Pages/getAll']
    },
    dialogItem: {
      // getter
      get() {
        return this.$store.state.Wording.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('Wording/UPDATE_DIALOG', newValue)
      }
    }
  },
  created() {},
  methods: {
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          const data = {
            ...this.formData,
            createdBy: localStorage.getItem('tokenAdmin')
          }
          await this.$store.dispatch(`Wording/insert`, data)
          this.$store.commit(`Wording/UPDATE_DIALOG`, false)
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    addItem() {
      this.$store.commit('Wording/UPDATE_DIALOG', true)
      this.$store.commit('Wording/SET_IDX', null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
